export class GeoTileSystemParams {YMin: any;YMax: any;XMin: any;XMax: any;
  constructor(a:any,b:any,c:any,d:any){
    this.XMax=a;
    this.XMin=b;
    this.YMax=c;
    this.YMin=d;
  }
}